import { Navigate }          from 'react-router-dom';
import { Outlet }            from 'react-router-dom';
import React                 from 'react';
import { useLocation }       from 'react-router-dom';
import { useTranslation }    from 'react-i18next';

const TranslatedRoute: React.FC = () => {
	const { i18n } = useTranslation();
	const location = useLocation();
	const languageFromUrl = location.pathname.split('/')[1];

    if (languageFromUrl === 'en' || languageFromUrl === 'fr') {
		return <Outlet />;
	} else {
		return <Navigate to={`/${i18n.language}${location.pathname}${location.search}${location.hash}`} />
	}
};

export default TranslatedRoute;